import { useState, useRef, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useUpdateCheck } from 'react-update-notification';
import './compStyles.css';

const NotificationContainer = () => {
    //Checks for new version every 20 minutes.
    const { status, reloadPage } = useUpdateCheck({
        type: 'interval',
        interval: 1200000
    });
    const [postpone, setPostpone] = useState(false)
    const [postponed, setPostponed] = useState(false)
    const fillRef = useRef(null);
    const duration = 120000;
    const [shouldAnimate, setShouldAnimate] = useState(false);

    const handleSetPostpone = (boolean) => {
        setPostpone(boolean)
        handleTimer();
    }

    const handleTimer = () => {
        console.log('Timer set for 2 minutes');
        setShouldAnimate(true)
        const timeoutId = setTimeout(() => {
            console.log("Update postpone time is up.");
            setPostponed(true)
            setPostpone(false);
        }, duration);
    }

    // This effect starts the animation when shouldAnimate becomes true
    useEffect(() => {
        if (shouldAnimate && fillRef.current) {
            // Reset in case of re-use
            fillRef.current.style.transition = 'none';
            fillRef.current.style.width = '0%';

            // Trigger reflow to ensure transition resets
            void fillRef.current.offsetWidth;

            // Then apply animation
            fillRef.current.style.transition = `width ${duration}ms linear`;
            fillRef.current.style.width = '100%';
        }
    }, [shouldAnimate]);

    if (status === 'checking' || status === 'current') {
        return null;
    }

    return (
        <>
            {status === "available" &&
                <>
                    {!postpone &&
                        <Modal
                            show={!postpone}
                            //onHide={}
                            size="sm"
                            centered
                            backdrop="static"
                        >
                            <>
                                <Modal.Header style={{ textAlign: "center", margin: "auto" }}><p className='bold-subheading-large'>There is an update available. Please refresh the page.</p></Modal.Header>
                                <div>
                                    <Modal.Body className="modal-body-text" style={{ textAlign: "center" }}>
                                        <button className="primary-button" style={{ width: "180px" }} type="button" onClick={() => reloadPage()}>
                                            Click here to refresh.
                                        </button>
                                    </Modal.Body>
                                    <Modal.Footer style={{ textAlign: "center", margin: "auto" }}>
                                        {postponed ? <p>You cannot postpone again. Please update.</p> : <p>You may postpone for two minutes to finish what you were doing. You will then have to refresh to continue.</p>}
                                        {!postponed &&
                                            <div style={{ textAlign: "center", margin: "auto" }}>
                                                <button className="secondary-button" style={{ width: "180px" }} disabled={postponed} type="button" onClick={() => handleSetPostpone(true)}>
                                                    Postpone for 120 seconds.
                                                </button>
                                            </div>
                                        }
                                    </Modal.Footer>
                                </div>
                            </>
                        </Modal >
                    }
                    {postpone && !postponed &&
                        <button className="primary-button progress-button minimized-button" type="button" onClick={() => reloadPage()}>
                            <span class="button-text">Click here to update.</span>
                            <div class="progress-fill" ref={fillRef}></div>
                        </button>
                    }
                </>
            }
        </>
    );
}; export default NotificationContainer